<template>
  <b-container>
    <slot v-if="initialized"></slot>
    <!-- <pre class="language-json">waypoint:<code>{{ waypoint  }}</code></pre> -->
  </b-container>
</template>
      
  <script>
export default {
  name: "LeafletWaypoint",
  props: {
    latitude: Number,
    longitude: Number,
  },
  components: {},
  mixins: [],
  data() {
    return {
      initialized: false,
      routingControl: null,
      waypoint: null,
    };
  },
  inject: ["addWaypoint", "getMap", "getRoutingControl", "setWaypointLocation"],
  methods: {
    destroy() {
      //   try {
      //     if (infobox) {
      //       let map = this.getMap();
      //       if (map) {
      //         infobox.setMap(null);
      //       }
      //     }
      //   } finally {
      //     this.setItem(null);
      //   }
    },
    render() {
      const location = L.latLng(this.latitude, this.longitude);
      this.waypoint = this.addWaypoint(location);
    },
  },
  beforeDestroy() {
    this.destroy();
  },
  mounted() {
    this.render();
  },
  watch: {
    latitude() {     
      if (!this.setWaypointLocation) return;
      if (!this.waypoint) return;
      if (this.waypoint == null) return;
      this.setWaypointLocation(this.waypoint.index, [
        this.latitude,
        this.longitude,
      ]);
    },
    longitude() {
      if (!this.setWaypointLocation) return;
      if (!this.waypoint) return;
      if (this.waypoint == null) return;
      this.setWaypointLocation(this.waypoint.index, [
        this.latitude,
        this.longitude,
      ]);
    },
  },
};
</script>
      